import styled from "styled-components";

export const FormWrapper = styled.form`
    font-size: 10px;
`;

export const ElementWrapper = styled.div`
    margin: ${(props) => props.margin || "10px"};
    overflow: ${(props) => props.overflow || "visible"};
    position: ${(props) => props.position};
`;

export default {
  FormWrapper,
  ElementWrapper
}
